module.exports = __webpack_public_path__ + "img/93.0a87a540.jpg";